import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Wynn from "@/pages/Wynn";
import WynnApp from "@/app/WynnApp";
import { AuthProvider } from "@/app/AuthContext";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Wynn />} />
            <Route path="/app/*" element={<WynnApp />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#0A0910",
            color: "#F4F1EC",
            border: "1px solid rgba(244,241,236,0.15)",
            borderRadius: "2px",
            fontFamily: "Outfit, system-ui, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
